import React from 'react'

import { Heading4, Body3, Space } from '@gousto-internal/citrus-react'

import { RecipeIngredientIncluded } from '@library/api-menu-experience/src/interfaces/recipe'

import { sanitize } from 'utils/sanitizer'

export const IngredientsContain = ({
  includedIngredients,
}: {
  includedIngredients?: RecipeIngredientIncluded[]
}) => (
  <div>
    {includedIngredients && includedIngredients?.length > 0 ? (
      <>
        <Heading4>Ingredients contain</Heading4>
        <Space size={4} />
        {includedIngredients.map((ingredient) => {
          const { text, subIngredientsHTML } = ingredient
          const sanitizedHtml = sanitize(subIngredientsHTML)
          const htmlWithStrong = `<strong>${text}:</strong> ${sanitizedHtml}`

          return (
            /* eslint-disable react/no-danger */
            <dl key={text} data-testid="ingredient">
              <Body3>
                <div dangerouslySetInnerHTML={{ __html: htmlWithStrong }} />
              </Body3>
            </dl>
          )
        })}
      </>
    ) : (
      <span />
    )}
  </div>
)
